<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="about-the-author">
<h1>About the Author</h1>
<p style="text-align: center;"><img alt="" src="media/file0.jpg" style="width:2.00861in;height:3.47917in; filter: grayscale(100%);"/></p><br/>
<p style="text-indent: 0em">Carmel Liddell’s latest novel, <em>Abbie Brown: On the Cusp</em>, explores the life and times of 34-year-old Abbie (single – 73kgs), who is looking for love.</p><br/>
<p style="text-indent: 0em">Having been there, and done that, Carmel tells the tale with a great deal of humour, affection and understanding.</p><br/>
<p style="text-indent: 0em">The Australian author’s other books include:</p><br/>
<p style="text-indent: 0em"><em>Short Stories A-Z</em> – 2023</p>
<p style="text-indent: 0em"><em>Love and Kisses Pauline xxx</em> – 2022</p>
<p style="text-indent: 0em"><em>Reggie Carstairs: Behind Closed Eyes</em> – 2021</p>
<p style="text-indent: 0em"><em>The Beachmaster (Childrens’ Picture Book)</em> - 2026</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch001.vue?05964d1d